<template>
  <div class="page">
    <div class="top-alert" v-if="clerkPostDaysApplyCount&&clerkPostDaysApplyCount!=-1">
      <div>今日剩余提交申请次数为{{todayRemainCount}}次</div>
      <div>已审核过的动态删除不会恢复次数</div>
    </div>

    <van-tabs v-model="activceTab" @change="onTabChange" :style="{ 'margin-top' : clerkPostDaysApplyCount && clerkPostDaysApplyCount != -1 ? '60px' : '0'}">
      <van-tab v-for="(tab, tabIndex) in tabNames" :name="tab.name" :title="tab.title" :key="tabIndex"/>
    </van-tabs>

    <van-list
        class="list-style"
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        :immediate-check="immediateCheck"
        @load="loadData"
    >
      <div class="dynamic" v-for="(item,index) in list" :key="index">
        <div class="dynamic-head">
          <div class="dynamic-img">
            <img :src="item.avatarUrl">
          </div>
          <div class="information">
            <div class="name-sex">
              <div class="dynamic-name">{{ item.clerkName }}</div>
              <div class="dynamic-sex">
                <span class="men" v-if="item.sex == $store.state.ClerkSexEnum.MEN.value">
                  <van-icon name="/static/images/default/post-male.png" size="13"/>
                </span>
                <span class="women" v-if="item.sex == $store.state.ClerkSexEnum.WOMEN.value">
                  <van-icon name="/static/images/default/post-female.png" size="13"/>
                </span>
              </div>
            </div>
            <div class="dynamic-date">{{ formatDate(item.createdTime, 'YYYY-MM-DD HH:mm') }}</div>
          </div>
          <div class="status" v-if="item.clerkPostCheckStatus != null">
            <van-tag class="unCheck" v-if="item.clerkPostCheckStatus == 0">待审核</van-tag>
            <van-tag class="unPass" v-if="item.clerkPostCheckStatus == -1">不通过</van-tag>
          </div>
        </div>
        <div class="dynamic-body">
          <div class="script" v-if="item.content">
            <span class="content">{{ item.content }}</span>
          </div>
          <div v-if="item.photoUrls.length > 0" style="margin-top: 12px">
            <van-image v-for="(img,index) in item.photoUrls"
                       :key="index"
                       style="margin: 0 4px 4px 0;"
                       :width="item.photoUrls.length == 1 ? 170 : 112"
                       :height="item.photoUrls.length == 1 ? 170 : 112"
                       fit="contain"
                       :src="img"
                       @click="HandleclickImg(item.photoUrls,index)"
            />
          </div>
          <div v-if="item.videoUrl" style="margin-top: 12px">
            <video width="100%" height="200px" :src="item.videoUrl" controls="controls" @play="handlePlay(index)"></video>
          </div>
          <div v-if="item.audioUrl">
            <div class="audio-player" :class="player.id == item.id ? 'playing' : ''"
                 @click="playAudio(item.id, item.audioUrl)">
              <div class="audio">
                <div class="audio-icon">
                  <img src="/static/images/default/play.png" style="width: 8px; height: 8px" v-if="player.id == item.id"/>
                  <img src="/static/images/default/play-stop.png" style="width: 8px; height: 8px" v-else/>
                </div>
                <div class="duration">{{ formatAudioDuration(item.audioDuration) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="dynamic-foot">
          <div class="likes" v-if="item.clerkPostCheckStatus == 1 || !item.clerkPostCheckId">
            <span><van-icon name="/static/images/default/like.png" size="22"/></span>
            <span class="text">{{ item.likeCount }}</span>
          </div>
          <div class="comment" v-if="item.clerkPostCheckStatus == 1 || !item.clerkPostCheckId"  @click="itemTo(item.id, false)">
            <div class="icon"><img src="/static/images/default/comment.png" style="width: 23px; height: 22px"/></div>
            <div class="text">{{ item.commentCount == 0 ? '评论' : item.commentCount}}</div>
          </div>
          <div class="edit" v-if="item.clerkPostCheckStatus == -1" @click="updatePost(item)">
            <span><van-icon name="/static/images/default/post-edit.png" size="22"/></span>
            <span class="edit-text">修改再申请</span>
          </div>
          <div class="delete" @click="deletedPost(item.id, index)">
            <span><van-icon name="/static/images/default/delete.png" size="22"/></span>
            <span class="text">删除</span>
          </div>
        </div>
      </div>
    </van-list>

    <div class="bottom-bar">
      <van-button :class="isAdd?'bottom-button':'bottom-button-forbid'" :to="isAdd?'/clerk/post/add':''">发布动态</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button, Dialog, Field, Icon, Image as VanImage, ImagePreview, List, Tab, Tabs, Tag, Toast} from 'vant';
import {deletedPost, getPostList} from '@/api/clerk/post'
import moment from "moment";
import Decimal from "decimal.js";
import {getApplyCount} from "../../../api/clerk/post";

Vue.use(VanImage)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(List)
    .use(Tab)
    .use(Tabs)
    .use(Tag)
    .use(ImagePreview)

export default {
  name: 'post-list',
  data() {
    return {
      videoElement: [],
      list: [],
      loading: false,
      listFinished: false,
      immediateCheck: false,
      pageNo: 1,
      pageSize: 10,
      player: {
        id: null,
        audio: null
      },
      isAdd: false,
      allowPostCheckSwitch: null,
      clerkPostDaysApplyCount: null,
      todayApplyCount: null,
      todayRemainCount:null,
      tabNames: [
        {'name': 'publish', 'title': '已发布'},
        {'name': 'unPublish', 'title': '我的申请'},
      ],
      activceTab: null,
      isPublish: true,
    }
  },
  methods: {
    itemTo(id){
      this.$router.push({
        path: '/clerk/post/detail/'+id
      })
    },
    onTabChange(){
      if(this.activceTab == 'publish'){
        this.isPublish = true
      }else if(this.activceTab == 'unPublish'){
        this.isPublish = false
      }
      this.loadData(true)
    },
    loadData(resetFirstPage) {
      Toast.loading({
        overlay: true,
        message: '加载中...'
      })
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getPostList(this.isPublish, this.pageNo, this.pageSize).then(res => {
        Toast.clear()
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.postList)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
      this.videoElement = document.getElementsByTagName('video')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + 's"'
      }
      return ''
    },
    HandleclickImg(photoUrls,index){
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    deletedPost(postId, index) {
      Dialog.confirm({
        title: '温馨提示',
        message: '确定要删除此动态吗?',
      })
          .then(() => {
            Toast.loading({
              overlay: true,
              message: '请稍候...'
            })
            deletedPost(postId).then(res => {
              Toast.clear()
              const data = res.data;
              if (data.code == 0) {
                this.list.splice(index, 1)
                this.videoElement = document.getElementsByTagName('video')
                Toast.success('删除成功')
              } else {
                Toast.success('删除失败')
              }
            })
          })
          .catch(() => {

          });
    },
    handlePlay (index) {
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if ( i == index) {
            this.videoElement[i].play()
            this.player.id = null
            this.player.audio = null
          }
        }
      }
    },
    updatePost(item){
      let type="img"
      if (item.photoUrls&&item.photoUrls.length>0){
        type="img"
      }else if (item.videoUrl){
        type="video"
      }else if (item.audioUrl){
        type="audio"
      }
      this.$router.push('/clerk/post/update/' + item.id + '?type=' + type);
    },

    getPostApplyCount(){
      getApplyCount().then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          if (!data.allowPostCheckSwitch){
            return this.isAdd=true
          }
          this.clerkPostDaysApplyCount=data.clerkPostDaysApplyCount;
          this.todayApplyCount=data.todayApplyCount;
          this.allowPostCheckSwitch=data.allowPostCheckSwitch;
          if (this.allowPostCheckSwitch && this.clerkPostDaysApplyCount!=-1) {
            this.todayRemainCount = this.clerkPostDaysApplyCount - this.todayApplyCount;
            this.todayRemainCount = Math.max(this.todayRemainCount, 0);
            this.isAdd = this.todayRemainCount > 0;
          } else {
            this.isAdd = true
          }
        } else {
          Toast.success('获取今日申请次数失败')
        }
      })
    }
  },
  activated() {
    this.loadData(true)
    this.getPostApplyCount()
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;
}

.top-alert {
  border: 1px solid #ffd77a;
  background-color: #fff9e6;
  text-align: center;
  padding: 10px 0 10px 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
.list-style{
  padding: 0 16px;
}
/deep/.van-tabs--line .van-tabs__wrap {
  height: 45px;
}

/deep/.van-tab--active {
  font-size: 14px;
  font-weight: bold;
}

/deep/.van-tab {
  font-size: 14px;
  background-color: rgb(248, 248, 248);
}

/deep/.van-image__img{
  border-radius: 8px;
}
/deep/.van-tabs__line{
  background-color: var(--primary-color);
  height: 2px;
}

.dynamic {
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #eeeeee;
}

.dynamic-head {
  width: 100%;
  height: 37px;
}

.dynamic-img {
  width: 37px;
  height: 37px;
  float: left;
}

.dynamic-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.information {
  float: left;
  margin: 0 0 0 10px;
  .name-sex{
    display: flex;
    align-items: center;
  }
}
.status{
  float: right;
  .unCheck{
    background-color: #F5F5F5;
    color: #999999;
    border: none;
    padding: 5px 8px;
    margin-right: 20px;
  }
  .unPass{
    background-color: #FFF0F0;
    color:#FF7B7E;
    border: none;
    padding: 5px 8px;
    margin-right: 20px;
  }
}

.dynamic-name {
  float: left;
  color: #191919;
  font-size: 15px;
}

.dynamic-date {
  font-size: 11px;
  text-align: center;
  color: #ACACAC;
}

.dynamic-sex {
  margin-left: 5px;
  height: 25px;
  line-height: 25px;
  float: left;
}

.dynamic-sex .men {
  color: #10cafe;
}

.dynamic-sex .women {
  color: #e6a0df;
}

.dynamic-follow {
  width: 55px;
  height: 25px;
  line-height: 25px;
  margin: 10px 0;
  font-size: 14px;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  color: red;
  border: 1px solid red;
}

.dynamic-body {
  width: 100%;
  .script{
    margin-top: 16px;
    .content{
      font-weight: 500;
      font-size: 15px;
      color: #191919;
    }
  }
}

.audio-player {
  width: 84px;
  height: 33px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-size: cover;
  background-color: #DEE9FF;
  border-radius: 50px;
  z-index: 3;
  margin-top: 18px;
  .audio {
    width: 100%;
    padding: 0 15px 0 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .audio-icon{
      background-color: rgba(120, 167, 255, 0.85);
      border-radius: 50%;
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .duration {
      font-size: 10px;
      font-weight: bold;
      color: #5892FF;
    }
  }

  &.playing {
    .wave {
      @keyframes wave {
        from {
          height: 18px;
        }
        to {
          height: 12px;
        }
      }
      animation: wave .5s linear 0s infinite alternate;
    }
  }
}
.play-tubiao{
  width: 14px;
  line-height: 14px;
  font-size: 6px;
  text-align: center;
}
.play-a{
  color: #fff;
  vertical-align: middle;
}
.dynamic-foot {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  margin-top: 15px;
  .likes, .comment, .delete{
    display: flex;
    align-items: center;
    margin-left: 30px;
    width: 70px;
    height: 22px;
    .icon{
      display: flex;
      align-items: center;
    }
    .text{
      font-weight: 500;
      font-size: 11px;
      color: #1A1A1A;
      margin-left: 2px;
    }
  }
  .edit{
    display: flex;
    align-items: center;
    margin-left: 30px;
    width: 100px;
    .edit-text{
      font-weight: 500;
      font-size: 11px;
      color: #333333;
      margin-left: 2px;
    }
  }
}
.liked {
  color: #1cbbb4;
}
.like-num{
  margin-left: 5px;
  padding-top: 3px;
  float: right;
  height: 25px;
  line-height: 25px;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  padding: 10px 0;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);

  .bottom-button {
    width: 42vw;
    height: 14vw;
    border-radius: 40px;
    border: none;
    background-color: var(--primary-color);
    color: white;
    font-size: 16px;
  }
  .bottom-button-forbid {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    background: #666;
    color: white;
  }
}

</style>
